import React from "react";
import ErrorShell, { GoHomeButton } from "./ErrorShell";
export default function NotFound() {
  return <ErrorShell code="404" title="Page not found" message="The page you are looking for doesn't exist or has been moved." action={<GoHomeButton label="Go to login" />} />;
}
